// Su mobile: swipe up sulla zona text-block mostra taglie, click normale va al prodotto
(function () {
  const MOBILE_BREAKPOINT = 749;
  const SWIPE_THRESHOLD = 50; // Pixel da swipare verso l'alto

  let touchStartY = 0;
  let touchStartX = 0;
  let touchStartTime = 0;
  let touchTarget = null;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  // Nascondi gli swatches su mobile di default
  function hideSwatchesOnMobile() {
    if (isMobile()) {
      document.body.classList.add('mobile-hide-swatches');
    } else {
      document.body.classList.remove('mobile-hide-swatches');
    }
  }

  hideSwatchesOnMobile();
  window.addEventListener('resize', hideSwatchesOnMobile);

  // Touch start - registra posizione iniziale
  document.addEventListener('touchstart', (event) => {
    if (!isMobile()) return;

    const target = event.target;
    const textBlock = target.closest('.group-block-content');
    
    if (!textBlock) return;

    const touch = event.touches[0];
    touchStartY = touch.clientY;
    touchStartX = touch.clientX;
    touchStartTime = Date.now();
    touchTarget = textBlock;
  }, { passive: true });

  // Touch end - determina se è swipe up
  document.addEventListener('touchend', (event) => {
    if (!isMobile() || !touchTarget) return;

    const touch = event.changedTouches[0];
    const deltaY = touchStartY - touch.clientY; // Positivo = swipe up
    const deltaX = Math.abs(touch.clientX - touchStartX);
    const deltaTime = Date.now() - touchStartTime;

    // Reset
    const wasSwipeUp = deltaY > SWIPE_THRESHOLD && deltaX < 30 && deltaTime < 300;
    
    if (wasSwipeUp) {
      // Trovare la product card
      const productCard = touchTarget.closest('.product-card');
      if (productCard) {
        event.preventDefault();
        
        // Mostra taglie con animazione dal basso
        productCard.classList.add('show-swatches-temp');
        
        // Vibrazione feedback
        if (navigator.vibrate) {
          navigator.vibrate(30);
        }
      }
    }

    touchTarget = null;
  }, { passive: false });

  // Chiudi taglie se si clicca fuori
  document.addEventListener('click', (event) => {
    if (!isMobile()) return;

    const target = event.target;
    const clickedOnSizes = target.closest('.product-card-sizes-minimal, swatches-variant-picker-component');
    
    if (!clickedOnSizes) {
      // Chiudi tutte le taglie aperte
      document.querySelectorAll('.product-card.show-swatches-temp').forEach(card => {
        card.classList.remove('show-swatches-temp');
      });
    }
  }, { passive: true });

})();
